import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import withWidth from '@material-ui/core/withWidth';

import {RespImg, Cta} from '../../ui';
import {theme} from '../../../themes/default-theme';
import Text from '../../typography';
import Video from '../YoutubeVideo';
import NextLink from '../../navigation/NextLink';

const Wrapper = styled.div`

`

const Container = styled.div`
  width: 100%;
  max-width: 1600px;
  max-height: 792px;
  margin: auto;
  overflow: hidden;
  display: flex;
  gap: 8px;

  > div {
    width: 50%;
  }

  ${theme.breakpoints.down("sm")} {
    flex-direction: column;
    overflow: visible;
    max-height: initial;
    gap: 4px;

    > div {
      width: 100%
    }
  }
`

const ImageColumnOne = styled.div`

  picture,
  img {
    width: calc(100% + 2px); // for spacing issue
  }

  ${theme.breakpoints.down("sm")} {
    > div {
      height: 284px;
      object-fit: cover;
      overflow: hidden;

      picture {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
`

const ImageColumnTwo = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1%;

  > div {
    flex: 49%;
    ${theme.breakpoints.down('sm')} {
      margin-bottom: 1%;
    }
  }

  > div:last-child {
    position: relative;
    width: 100%;
    height: 50%;
    overflow: hidden;

    picture {
      object-fit: cover;
    }
  }
`

const ImageContainer = styled.div`
  position: relative;
  overflow: hidden;

  ${props => props.bgColour !== null && `
    background-color: ${props.bgColour};
  `}
`

const ImageContentContainer = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  max-width: 560px;

  &:before {
    content: '';
    width: 100%;
    height: 100%;
  }

  ${theme.breakpoints.down("sm")} {
    padding: 40px 29px;
  }
`

const Title = styled(props => {
  return <Text {...props} />
})`
  text-align: center;
  margin-bottom: 10px;

`

const BodyText = styled(props => {
  return <Text {...props} />
})`
  text-align: center;
`

const CtaItem = styled.div`
  margin-top:35px;
  text-align:center;
  ${theme.breakpoints.down("sm")} {
    margin-top:25px;
  }
  a {
    display:inline-block;
    width:auto;
    margin:auto;
  }
`

const SizzleImageGrid = (props) => {

  const {
    data,
    imageHighlight,
    colourTheme,
    background,
    cta
  } = props

  return (
    <Wrapper colourTheme={colourTheme} backgroundColor={background}>
      <Container>
        {data &&
          <>
            <ImageColumnOne>
              <ImageContainer>
                <RespImg 
                  {...data[0].image}
                />
              </ImageContainer>
            </ImageColumnOne>
            <ImageColumnTwo>
              {data.slice(1, 3).map(function(item, i) {
                return (
                  <ImageContainer key={i}>
                    <RespImg 
                      {...item.image}
                    />
                  </ImageContainer>
                )
              })}

              {(imageHighlight && (imageHighlight.image || imageHighlight.backgroundColour || imageHighlight.title || imageHighlight.text)) &&
                <ImageContainer bgColour={imageHighlight.backgroundColour && imageHighlight.backgroundColour.hex}>
                  {imageHighlight.image &&
                    <RespImg 
                      {...imageHighlight.image}
                    />
                  }
                  {((imageHighlight.title || imageHighlight.text)) &&
                    <ImageContentContainer>
                      {imageHighlight.title &&
                        <Title variant="h3" weight={800} colour="white" uppercase={true}>{imageHighlight.title}</Title>
                      }
                      {imageHighlight.text &&
                        <BodyText variant="body1" colour="white"><div dangerouslySetInnerHTML={{__html: imageHighlight.text}} /></BodyText>
                      }
                    </ImageContentContainer>
                  }
                </ImageContainer>
              }
            </ImageColumnTwo>
          </>
        }
      </Container>      
        {cta &&
          <CtaItem>
            <NextLink href={cta.href}>
              <a target={cta.target}>
                <Cta component="span" inline>
                  {cta.title}
                </Cta>
              </a>
            </NextLink>
          </CtaItem>
        }
    </Wrapper>
  )
}

SizzleImageGrid.propTypes = {
  data: PropTypes.array,
  imageHighlight: PropTypes.object
};

SizzleImageGrid.defaultProps = {
  data: [],
  imageHighlight: {},
  colourTheme: null,
  background: null,
}
  
export default withWidth()(SizzleImageGrid)
